import script from "./EditCouponUserForm.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCouponUserForm.vue?vue&type=script&setup=true&lang=js"

import "./EditCouponUserForm.vue?vue&type=style&index=0&id=aaf44896&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaf44896"]])

export default __exports__